import { useEffect, useState } from 'react';

type EventCallbackMap = Partial<Record<'onFocus' | 'onBlur', CallableFunction>>;
type HookOptions = { defaultValue?: boolean };

export function useWindowFocus({ onFocus, onBlur, defaultValue = true }: EventCallbackMap & HookOptions = {}): boolean {
    const [focused, setFocused] = useState<boolean>(defaultValue);

    useEffect(() => {
        setFocused(window.document.hasFocus());
        const handleBlur = () => {
            setFocused(false);
            onBlur?.();
        };

        const handleFocus = () => {
            setFocused(true);
            onFocus?.();
        };

        window.addEventListener('blur', handleBlur);
        window.addEventListener('focus', handleFocus);
        return () => {
            window.removeEventListener('blur', handleBlur);
            window.removeEventListener('focus', handleFocus);
        };
    }, [onBlur, onFocus, setFocused]);

    return focused;
}
